// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns20Circle: FC<Returns20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path
                d="M12 24.076c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12s-12 5.372-12 12c0 6.627 5.373 12 12 12Zm-4-9v1.5h6c1.111 0 2.055-.389 2.833-1.167.778-.777 1.167-1.722 1.167-2.833 0-1.111-.389-2.056-1.167-2.833-.777-.778-1.722-1.167-2.833-1.167H8.875l1.938-1.938L9.75 5.576 6 9.326l3.75 3.75 1.063-1.063-1.938-1.937H14a2.41 2.41 0 0 1 1.77.73 2.41 2.41 0 0 1 .73 1.77 2.41 2.41 0 0 1-.73 1.77 2.41 2.41 0 0 1-1.77.73H8Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Returns20Circle;
